import styled from "styled-components"
import { Tooltip as ReactTooltip } from "react-tooltip"

export const BarContainer = styled.div<{
  $color: string
  $width: string
  $start: string
  $isPreview?: boolean
}>`
    position: absolute;
    top: 50%;
    left: ${props => props.$start};
    width: ${props => props.$width};
    height: 2.5rem;
    background: ${props => props.$color};
    transform: translateY(-50%);
    z-index: 2;
    pointer-events: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 0.8rem;
    border-radius: 1.5rem;
    overflow: hidden;

    &:hover {
        cursor: ${props => props.$isPreview ? 'default' : 'pointer'};
    }
`

export const CampaignName = styled.span`
  color: white;
  font-size: 1.2rem;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const StyledTooltip = styled(ReactTooltip)`
  background: ${p => p.theme.colors.greenDark} !important;
  border-radius: 0.4rem !important;
  padding: 1.2rem 1.6rem !important;
  font-size: 1.1rem !important;
  line-height: 2rem !important;
  box-shadow: 0 0.4rem 0.8rem rgba(0, 0, 0, 0.15) !important;
  opacity: 1 !important;
  z-index: 3;
  transition: none !important;

  &:after {
    border-top-color: ${p => p.theme.colors.greyDark} !important;
  }
`

export const TooltipContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`

export const TooltipTitle = styled.div`
  font-weight: 600;
  margin-bottom: 0.4rem;
`

export const TooltipRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;

    svg {
        fill: ${p => p.theme.colors.white};
        height: 1.1rem;
    }
`

export const TooltipAction = styled.div`
  margin-top: 0.8rem;
  font-size: 1.2rem;
`
